module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.data.formId
    }
  }, [_c('div', {
    staticClass: "form-popup"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.data.header))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_name),
      expression: "client_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.field1.placeholder
    },
    domProps: {
      "value": (_vm.client_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "validation-error",
    attrs: {
      "error": _vm.showRequiredName
    }
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v(_vm._s(_vm.field1.validator))])])]), _vm._v(" "), _c('label', {
    staticClass: "phone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_phone),
      expression: "client_phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": _vm.field2.placeholder
    },
    domProps: {
      "value": (_vm.client_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "validation-error",
    attrs: {
      "error": _vm.showRequiredPhone
    }
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v(_vm._s(_vm.field2.validator))])])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.click
    }
  }, [_vm._v(_vm._s(_vm.data.button_2))]), _vm._v(" "), _c('grecaptcha', {
    attrs: {
      "request": _vm.request,
      "payload": _vm.payload
    },
    on: {
      "SENDFORM": _vm.onRecaptchaSubmit
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-660801e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/form-popup.vue
// module id = 396
// module chunks = 14